//alert 标题
export const MESSAGE_TITLE = '提示'
export const DISPOSE_SUCCESS = '操作成功'
export const DISPOSE_ERROR = '操作失败'
export const SUBMIT_SUCCESS = '提交成功'
export const SUBMIT_ERROR = '提交失败'
//分页数组
export const PAGE_ARR = [20, 50, 100, 200]

//通用域名
export const COMMON_URL = (process.env.NODE_ENV === 'development' ? '' :globalConst.COMMON_URL)

//测试环境接口地址，上线时需要更改给正式接口地址
export const EXPORT_URL = globalConst.COMMON_URL



// WEBPACK FOOTER //
// ./src/assets/js/const.js